export default {
  MAPBOX_PROVIDER: 'mapbox',
  GOOGLEMAPS_PROVIDER: 'google',
  STATIC: 'static'
};
